import React from "react";
import BondPlayInfoModal from "../bond-play/BondPlayInfoModal";
import {
  DRAW_COUNT,
  formatDrawCoin,
  MAX_SELECTION,
  PRICE_PER_NUMBER,
  TOTAL_NUMBERS,
} from "../../utils/bondDrawHelpers";
import { PENDING_ROUND_EXPIRE_MS } from "../../utils/bondDrawPendingExpiry";

const EXPIRE_SECONDS = Math.round(PENDING_ROUND_EXPIRE_MS / 1000);

const BondDrawInfoModal = ({ open = false, onClose }) => (
  <BondPlayInfoModal
    open={open}
    onClose={onClose}
    titleId="bdraw-info-title"
    title="Bond Draw"
    subtitle={`Pick numbers, reserve your ticket, then draw ${DRAW_COUNT} winning balls.`}
    sections={[
      {
        title: "Pick & reserve",
        items: [
          <>Choose 1–{MAX_SELECTION} numbers from 1–{TOTAL_NUMBERS} on the grid.</>,
          <>Each number costs {formatDrawCoin(PRICE_PER_NUMBER)} COIN ({formatDrawCoin(PRICE_PER_NUMBER * MAX_SELECTION)} max stake).</>,
          <>Tap <strong>Reserve ticket</strong> to lock your picks and hold pool coverage.</>,
        ],
      },
      {
        title: "Draw window",
        items: [
          <>After reserving, you have {EXPIRE_SECONDS} seconds to tap <strong>Draw now</strong>.</>,
          <>Cancel anytime before drawing to refund your full stake.</>,
          <>If time expires, the ticket is void and your stake is refunded automatically.</>,
        ],
      },
      {
        title: "Winning",
        items: [
          <>{DRAW_COUNT} numbers are drawn at random when you play.</>,
          <>Match your picks to win — more matches mean a higher payout.</>,
          <>Odds depend on how many numbers you picked; max win is shown on your ticket.</>,
          <>A 5% platform fee applies to profit on winning rounds only.</>,
        ],
      },
      {
        title: "Investor pool",
        items: [
          <>Max wins are backed by the Bond Draw investor pool shown in the side panel.</>,
          <>If the pool is too low for your ticket, try fewer picks or wait for more liquidity.</>,
        ],
      },
    ]}
  />
);

export default BondDrawInfoModal;
